<template>
  <div>
    <span class="moow-info-txt">{{title}}</span>
    <span class="moow-info-txt small">{{hint}}</span>
    <b-row>
      <b-col>
        <md-field :class="{ 'md-invalid': inputErr_day }">
          <label>Day</label>
          <md-input v-model="inputDay" type="number" :disabled="readonly"></md-input>
          <span class="md-error">{{inputErr_day}}</span>
        </md-field>
      </b-col>
      <b-col>
        <md-autocomplete
          :md-open-on-focus="openOnFocus"
          v-model="inputMonth"
          :md-options="monthOptions"
          :class="{ 'md-invalid': inputErr_month }"
          :disabled="readonly"
        >
          <label>Month</label>
          <span class="md-error">{{inputErr_month}}</span>
        </md-autocomplete>
      </b-col>
      <b-col>
        <md-field :class="{ 'md-invalid': inputErr_year }">
          <label>Year</label>
          <md-input v-model="inputYear" type="number" :disabled="readonly"></md-input>
          <span class="md-error">{{inputErr_year}}</span>
        </md-field>
      </b-col>
    </b-row>
    <!-- <div class="md-layout">
      <div class="md-layout-item md-size-20">
        <md-field :class="{ 'md-invalid': inputErr_day }">
          <label>Day</label>
          <md-input v-model="inputDay" type="number" :disabled="readonly"></md-input>
          <span class="md-error">{{inputErr_day}}</span>
        </md-field>
      </div>
      <div class="md-layout-item md-size-45 ml-2">
        <md-autocomplete
          :md-open-on-focus="openOnFocus"
          v-model="inputMonth"
          :md-options="monthOptions"
          :class="{ 'md-invalid': inputErr_month }"
          :disabled="readonly"
        >
          <label>Month</label>
          <span class="md-error">{{inputErr_month}}</span>
        </md-autocomplete>
      </div>
      <div class="md-layout-item md-size-25 ml-2">
        <md-field :class="{ 'md-invalid': inputErr_year }">
          <label>Year</label>
          <md-input v-model="inputYear" type="number" :disabled="readonly"></md-input>
          <span class="md-error">{{inputErr_year}}</span>
        </md-field>
      </div>
    </div> -->
  </div>
</template>

<script>
// import { monthList } from "../../lists.js";
const lists = require("@/lists.js");

import { dayPossibleInMonth } from "@/timeFunctions.js";
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    hint: {
      type: String,
      required: false
    },
    openOnFocus: {
      type: Boolean,
      default: false
    }
  },

  components: {},
  data() {
    return {
      inputErr_day: "",
      inputErr_month: "",
      inputErr_year: "",
      inputDay: undefined,
      inputMonth: undefined,
      inputYear: undefined,
      monthOptions: lists.monthList
    };
  },
  watch: {
    date: function(val, oldVal) {
      if (val && val != oldVal) this.setDateToForm(val);
    },
    inputDay: function(val, oldVal) {
      if (val) this.inputErr_day = "";
    },
    inputMonth: function(val, oldVal) {
      if (val) this.inputErr_month = "";
    },
    inputYear: function(val, oldVal) {
      if (val) this.inputErr_year = "";
    }
  },
  computed: {},
  mounted() {
    this.date ? this.setDateToForm(this.date) : void 0;
  },
  created() {},
  methods: {
    clear() {
      this.inputErr_day = "";
      this.inputErr_month = "";
      this.inputErr_year = "";
      this.inputDay = undefined;
      this.inputMonth = undefined;
      this.inputYear = undefined;
    },
    getDate() {
      var m = this.monthOptions.indexOf(this.inputMonth) + 1;
      return this.inputYear + "-" + m + "-" + this.inputDay;
    },
    getOptionalDate() {
      if (this.validateFormWOErrors()) return this.getDate();
      else return undefined;
    },
    getValidDate() {
      if (this.validateForm()) return this.getDate();
      else return false;
    },
    setDateToForm(date) {
      if (date) {
        var ds = date.split("-");
        this.inputYear = ds[0];
        this.inputMonth = this.monthOptions[Number(ds[1]) - 1];
        this.inputDay = ds[2];
      }
    },
    validateForm() {
      var success = true;
      if (!this.validateYear(this.inputYear)) {
        success = false;
        this.inputErr_year = "Invalid";
      }

      if (!this.validateMonth(this.inputMonth)) {
        success = false;
        this.inputErr_month = "Invalid";
      }

      if (!this.validateDay(this.inputDay, this.inputMonth, this.inputYear)) {
        success = false;
        this.inputErr_day = "Invalid";
      }
      return success;
    },
    validateFormWOErrors() {
      var success = true;
      success = this.validateYear(this.inputYear);
      success = this.validateMonth(this.inputMonth);
      success = this.validateDay(
        this.inputDay,
        this.inputMonth,
        this.inputYear
      );
      return success;
    },
    validateYear(input) {
      if (input && input > 1900 && input < 3000) return true;
      return false;
    },
    validateMonth(input) {
      if (input && this.monthOptions.includes(input)) return true;
      return false;
    },
    validateDay(day, month, year) {
      if (day && day >= 1 && day <= 31 && dayPossibleInMonth(day, month, year))
        return true;
      else return false;
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/utils/dateInput.vue